import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface TrendingBook {
  id: string;
  title: string;
  authors: string[];
  cover_url?: string;
  cover_cache_url?: string;
  rating_count: number;
  average_rating: number;
}

export const useTrendingBooks = () => {
  return useQuery({
    queryKey: ['trendingBooks'],
    queryFn: async (): Promise<TrendingBook[]> => {
      const thirtyDaysAgo = new Date();
      thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

      const { data, error } = await supabase
        .from('books')
        .select('id, title, authors, cover_url, cover_cache_url, rating_count, average_rating, last_rated_at')
        .gte('last_rated_at', thirtyDaysAgo.toISOString())
        .gte('rating_count', 3)
        .order('rating_count', { ascending: false })
        .limit(10);

      if (error) throw error;
      return data || [];
    },
    staleTime: Infinity,
    gcTime: 1000 * 60 * 60 * 24, // 24 hours
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};
